"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Flex = require("../Flex");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledFlex = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Message__StyledFlex",
  componentId: "t49v7v-0"
})(["background-color:", ";border-radius:2px;"], function (_ref) {
  var variant = _ref.variant;

  if (variant === "info") {
    return (0, _helpers.color)("blue10");
  } else if (variant === "warning") {
    return (0, _helpers.color)("copper10");
  } else {
    return (0, _helpers.color)("black5");
  }
});
/**
 * A generic message window for displaying ZerStates, notices, errors, etc.
 *
 * Spec: zpl.io/2Zg4Rdq
 */

var Message = function Message(_ref2) {
  var children = _ref2.children,
      _ref2$textSize = _ref2.textSize,
      textSize = _ref2$textSize === void 0 ? "3t" : _ref2$textSize,
      others = _objectWithoutProperties(_ref2, ["children", "textSize"]);

  return /*#__PURE__*/_react.default.createElement(StyledFlex, _extends({
    p: 2
  }, others), /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    size: textSize,
    color: (0, _helpers.color)("black100"),
    weight: "regular"
  }, children));
};

exports.Message = Message;
Message.displayName = "Message";
//# sourceMappingURL=Message.js.map